
import axios from 'axios'

const apiTesting = "http://10.53.25.122:5000"

export const getGrandprize = async ({commit}) => {
  try {
    const {data} = await axios.get(`${process.env.VUE_APP_API2}/api/grandprizes`)
    console.log(data.data, "<<data di action")
    commit('SET_GRANDPRIZE', data.data)
  } catch (error) {
    console.log(error)
  }
}

export const postWinnersGrandprize = async ({commit}, payload) => {
  try {
    console.log(payload, "<< gp siap post ke api")
    const responseWinners = await axios.post(`${process.env.VUE_APP_API2}/api/winners/post`, {userId: payload})
    console.log(payload, responseWinners, "<<data di action")
  } catch (error) {
    console.log(error, payload)
  }
}

export const postPerson = async (context, payload) => {
  try {
    payload.forEach( async item => {
      
      const responseWinners = await axios.post(`${process.env.VUE_APP_API2}/api/prizes/winners/${item.prizeId}`, {userId: item.winners})
      // const responseWinners = await axios.post(`${apiTesting}/api/prizes/winners/${+item}`)
      console.log(responseWinners, "<< response")
    })
    // const responsePrize = await axios.post(`${apiTesting}/api/prizes/winners/${payload.prizeId}`, {userId: payload.winners})
    // // const responseWinners = await axios.post(`${apiTesting}/api/prizes/winners/post`, {userId: payload.winners})
    // console.log(payload, responsePrize, '< response prize doorprize payload')
    // console.log(responseWinners, '< responseWinners doorprize payload')     
  } catch (error) {
    console.log(payload, error, "< update data doorprize error")
  }
}